///<reference path="../common/data-template-base.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class PackageTypesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected packageTypes: PackageTypesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.packageTypes;
        }

        get leafCollection() {
            return this.packageTypes;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[0]];
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.packageTypes = new PackageTypesCollection(this.model[properties[0]], [], {
                criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.allSelectedLabel = 'LABEL_ALL_PACKAGES';
            this.totalSelectedMessage = 'LABEL_TOTAL_PACKAGES_SELECTED';
        }
    }
}